/** Tallest a menu may grow at each width breakpoint from useResponsive. */
const HEIGHT_CAP = {
  xsm: 220,
  sm: 240,
  md: 280,
  lg: 320,
  xl: 320,
  "2xl": 320,
};

const GAP = 6;
const EDGE = 8;

/**
 * Place a menu next to its trigger so it stays inside a modal or the screen.
 * The breakpoint only caps the height. The side and the real height come
 * from the space above and below the trigger.
 */
export function placeAnchoredMenu({
  anchorRect,
  boundaryRect,
  viewportHeight,
  screenSize = "lg",
}) {
  const cap = HEIGHT_CAP[screenSize] || HEIGHT_CAP.lg;
  const spaceBelow = Math.max(
    0,
    Math.min(viewportHeight, boundaryRect.bottom) - anchorRect.bottom - GAP - EDGE
  );
  const spaceAbove = Math.max(
    0,
    anchorRect.top - Math.max(0, boundaryRect.top) - GAP - EDGE
  );
  const openUp = spaceBelow < 200 && spaceAbove > spaceBelow;
  const room = Math.floor(openUp ? spaceAbove : spaceBelow);
  let maxHeight = Math.min(cap, Math.max(0, room));
  const maxWidth = Math.max(120, boundaryRect.width - EDGE * 2);
  const width = Math.min(anchorRect.width, maxWidth);
  let left = anchorRect.left - boundaryRect.left;
  if (left + width > boundaryRect.width - EDGE) {
    left = boundaryRect.width - EDGE - width;
  }
  left = Math.max(EDGE, left);
  let top = openUp
    ? anchorRect.top - boundaryRect.top - GAP - maxHeight
    : anchorRect.bottom - boundaryRect.top + GAP;
  if (top < EDGE) {
    maxHeight = Math.max(0, maxHeight - (EDGE - top));
    top = EDGE;
  }
  const bottomLimit = boundaryRect.height - EDGE;
  if (top + maxHeight > bottomLimit) {
    maxHeight = Math.max(0, bottomLimit - top);
  }

  return {
    position: "absolute",
    width,
    left,
    top,
    maxHeight,
    zIndex: 40,
  };
}
